<template>

  <div class="avatar">
    <div class="avatar-main" id="avatar-main-id" @click="expandirAvatar"  @mouseover="efeitoMouseOver" @mouseleave="efeitoMouseLeave">
        <div class="avatar-img">
            <!--<img id="user-avatar"
                :src="require('@/thumbler/' + usuario.foto)"
                alt="Avatar do Perfil" 
            />-->
            <b-img-lazy 
                    :src="require('@/thumbler/' + usuario.foto)" 
                    alt="Avatar do Perfil" 
                    id="user-avatar">
            </b-img-lazy>
        </div>
        <i class="fas fa-angle-down" id="avatar-seta"></i>
    </div>

    <div id="avatar-conteudo" class="avatar-expand" @mouseover="efeitoMouseOver" @mouseleave="efeitoMouseLeave">
        <div id="avatar-conteudo-header" class="avatar-conteudo-header-fundo" >
            <!--<img id="user-imagem" class="avatar-header-thumbnail"
                :src="require('@/thumbler/' + usuario.foto)"
                alt="Imagem de perfil do usuário"
            />-->
            <b-img-lazy 
                    :src="require('@/thumbler/' + usuario.foto)" 
                    alt="Imagem de perfil do usuário" 
                    class="avatar-header-thumbnail"
                    id="user-imagem">
            </b-img-lazy>
            <div id="avatar-nome" class="avatar-header-titulo">{{ limitaTitulo }}</div>
            <div id="avatar-email" class="avatar-header-email">{{ limitaEmail }}</div>
        </div>
        <span id="avatar-home" class="avatar-conteudo-botao" @click.prevent="goHome">
            <i class="fas fa-house-user ml-2 mr-3"></i>Página inicial
        </span>
        <span id="avatar-perfil" class="avatar-conteudo-botao"><i class="far fa-address-card ml-2 mr-3"></i>Editar perfil</span>
        <span id="avatar-config" class="avatar-conteudo-botao"><i class="fas fa-user-cog ml-2 mr-3"></i>Configurações</span>
        <span id="avatar-logoff" class="avatar-conteudo-botao" @click.prevent="logout">
            <i class="fas fa-sign-out-alt ml-2 mr-3"></i>Sair
        </span>
    </div>
  </div>
</template>

<script>
import { userKey } from '../../global'
import { mapState } from 'vuex'
import { ekarApyaba } from '../../config/piht/cv.js'

export default {
    name: 'avatar',
    components: { },
    computed: {
        ...mapState(['usuario']),
        limitaTitulo: function () {
            const entrada = this.usuario.apelido ? this.usuario.apelido : this.usuario.nome_razao;
            let saida = '';
 
            if(entrada.length >= 15) {
                saida = entrada.substring(0, 14);
                saida += "...";
            } else saida = entrada;
            
            return saida
        },
        limitaEmail: function () {
            const entrada = this.usuario.email
            let saida = '';
 
            if(entrada.length >= 18) {
                saida = entrada.substring(0, 17);
                saida += "...";
            } else saida = entrada;

            return saida
        },

    },
    data: function() {
        return {
            expandido: false,
        }
    },
    methods: {
        expandirAvatar() {
            this.expandido = !this.expandido;

            if (this.expandido) {
                const alvo = document.getElementById("avatar-conteudo");
                alvo.classList.add("expand-visivel");
                
                const ctrlSeta = document.getElementById("avatar-seta");
                ctrlSeta.classList.remove("fa-angle-down");
                ctrlSeta.classList.add("fa-angle-up");
                window.addEventListener('click', this.fecharClickExterno);
            } else {
                const alvo = document.getElementById("avatar-conteudo");
                alvo.classList.remove("expand-visivel");
                
                const ctrlSeta = document.getElementById("avatar-seta");
                ctrlSeta.classList.remove("fa-angle-up");
                ctrlSeta.classList.add("fa-angle-down");
                window.removeEventListener('click', this.fecharClickExterno);
            }
        },
        efeitoMouseOver() {
            const setaAvatar = document.getElementById("avatar-seta");
            setaAvatar.style.transition = "all 1s";
            setaAvatar.style.color = "white";
            const bordaAvatar = document.getElementById("user-avatar");
            bordaAvatar.style.transition = "all 1s";
            bordaAvatar.style.border = "solid 2px #fff";
        },
        efeitoMouseLeave() {
            const setaAvatar = document.getElementById("avatar-seta");
            setaAvatar.style.color = "#aaa";
            const bordaAvatar = document.getElementById("user-avatar");
            bordaAvatar.style.border = "solid 2px #000";
        },
        fecharClickExterno() {
            if ( this.$mq !== 'xs' ) {
                const alvo = document.getElementById("avatar-conteudo");
                const botao = document.getElementById('avatar-main-id');

                const ClickDentro = alvo.contains(event.target);
                const ClickBotao = botao.contains(event.target);

                if(!ClickBotao)   {  //so executa de clicou fora do botao
                //console.log('aqui')
                    if(!ClickDentro) {
                        //Se clicou fora efetua o fechamento do menu avatar
                        alvo.classList.remove("expand-visivel");
                        const ctrlSeta = document.getElementById("avatar-seta");
                        ctrlSeta.classList.remove("fa-angle-up");
                        ctrlSeta.classList.add("fa-angle-down");
                        this.expandido = false;
                        window.removeEventListener('click', this.fecharClickExterno);
                    }
                }
            } else {
                this.expandido = false;
                window.removeEventListener('click', this.fecharClickExterno);
            }
        },
        logout() {
            this.expandirAvatar(); //fecha menu 
            localStorage.removeItem(userKey)
            this.$store.commit('setUser', null)
            this.$router.push({ name: 'Auth' })
        },
        goHome() {
            this.expandirAvatar(); //fecha menu
            ekarApyaba(this.usuario, this.$router.currentRoute.path);//executa acao de ctrl //////////
            if(this.$mq === 'sm' || this.$mq === 'md') {
                this.$nextTick(function () {
                    this.$store.commit('alternaMenu', false);
                });
            }
        },
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
    }
}
</script>

<style>
/* conteudo do avatar dentro do header principal e estrutura para abris janela do sub menu */
.avatar {
    position: relative;
    height: 85px;
    width: 85px;
}

.avatar-img {
    margin: 0px 2px 0px 15px;
}

.avatar-img > img {
    max-height: 52px;
    max-width: 52px;
    border-radius: 50px;
    border: solid 2px #000;
}

.avatar-main {
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
}

.avatar-main:hover{
    cursor: pointer;
}

#avatar-seta {
    color: #aaa;
}

.avatar-expand {
    position: absolute;
    right: -78px;
    background-color: #fff;
    min-width: 280px;
    min-height: 277px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 7;
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow: hidden;

    visibility: hidden;
    opacity: 0;
    transition: visibility 0.5s, opacity 0.5s linear;
}

.expand-visivel {
    visibility: visible;
    opacity: 1;
}
/* ***************************************************************/

/* Conteudo do cabeçalho do menu **********************************/
.avatar-conteudo-header-fundo {
    background-image: url("../../assets/hion_18.png");
    background-color: #000;
    /*background-image: linear-gradient(to bottom right, #008fac , #004f5f);*/

    /* Center and scale the image nicely */
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    /* Needed to position the navbar */
    position: relative;
    height: 100px;
    width: 280px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
.avatar-header-thumbnail {
    max-height: 72px;
    max-width: 72px;
    border-radius: 50px;
    margin-top: 14px;
    margin-left: 20px;
    box-shadow: 0px 2px 2px #2e2d2c;
}
.avatar-header-titulo {
    text-decoration: none;
    max-height: 20px;
    max-width: 160px;
    margin-left: 10px;
    display: inline-block;
    color: #fff;
    text-shadow: 0px 2px 2px #000000;
    font-family: "Play", sans-serif;
    font-size: 17px;
}
.avatar-header-email {
    text-decoration: none;
    max-height: 20px;
    max-width: 160px;
    margin-left: 102px;
    margin-top: -34px;
    color: #eee;
    font-family: Helvetica,Arial;
    font-size: 14px;
}
.avatar-conteudo-botao {
    text-decoration: none;
    border:none;
    height: 43px;
    width: 280px;
    padding: .75rem 1.5rem;
    color: #2e2d2c;
    background-color: #fff;
}
.avatar-conteudo-botao i {
    font-size: 19px;
}
.avatar-conteudo-botao:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
    font-weight: bold;
}
.avatar-conteudo-botao:hover i {
    color: #007188;
}
/* ***************************************************************/


/* MEDIA QUERY XS, SM E MD *********************************************************/
@media (max-width:991px) {
    .avatar-expand {
        right: -8px;
    }
}

</style>